import TYPES from '@/types';

import Vue from 'vue';

// application
import UpdateInvestorGoalDatesCommand
  from '@/modules/flagship/investor-goal/investor-goal-dates/application/commands/update-investor-goal-dates-command';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class ThirtyDaysNoticeSummaryViewModel {
  @Inject(TYPES.UPDATE_INVESTOR_GOAL_DATES_COMMAND)
  private readonly update_investor_goal_dates_command!: UpdateInvestorGoalDatesCommand;

  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  readonly i18n_namespace = 'components.flagship.flagship-link-goals.thirty-days-notice-summary';

  readonly view: Vue;

  constructor(view: Vue) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  updateInvestorGoalDates = async (
    investor_goal_id: string, investment_goal_type_id: string, period: number,
  ) => {
    try {
      const investor_goal_dates_dto_custom = {
        investor_goal_id,
        investment_goal_type_id,
        period,
      };
      await this.update_investor_goal_dates_command.execute(investor_goal_dates_dto_custom);
      this.view.$emit('updated');
      return true;
    } catch {
      this.message_notifier.showErrorNotification(this.translate('errors.patch_dates'));
      return false;
    }
  }

  back = () => {
    this.view.$emit('back');
  };
}
